import { UsersBody } from "@reflag/shared/userAPI";

const qk = {
  list: (appId?: string, envId?: string, params?: Omit<UsersBody, "envId">) =>
    [
      "apps",
      appId,
      "environments",
      envId,
      "users",
      ...(params ? [params] : []),
    ] as const,

  single: (appId?: string, envId?: string, userId?: string) =>
    [...qk.list(appId, envId), userId] as const,

  userNames: (
    appId?: string,
    envId?: string,
    params: Record<string, any> = {},
  ) =>
    [...qk.list(appId, envId), "names", ...(params ? [params] : [])] as const,
};

export { qk as userQueryKeys };
